import { otsBaseApi } from "../../ots-api";
import { UnitOfMeasure } from "../../../model/unit-of-measure";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({ addTagTypes: ["UnitOfMeasures"] });

const uomApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUnitOfMeasures: builder.query<UnitOfMeasure[], undefined>({
      query: () => ({
        url: `/unit-of-measures/all`,
        method: "GET"
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({ id }) => ({ type: "UnitOfMeasures", id } as const)),
            { type: "UnitOfMeasures", id: "LIST" }
          ];
        } else {
          return [{ type: "UnitOfMeasures", id: "LIST" }];
        }
      }
    })
  })
});

export const {
  useGetAllUnitOfMeasuresQuery
} = uomApi;
